import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ to, text, external = false, className = '', onClick }) => {
  const buttonClass = `btn btn-custom ${className}`;

  if (external) {
    return (
      <a 
        href={to} 
        className={buttonClass} 
        target="_blank" 
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {text}
      </a>
    );
  }

  if (onClick) {
    return (
      <button 
        className={buttonClass} 
        onClick={onClick}
      >
        {text}
      </button>
    );
  }

  return (
    <Link to={to} className={buttonClass}>
      {text}
    </Link>
  );
};

export default Button;